(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		if (!this.header) return;

		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = this.getScrollTop();
		this.scrollThreshold = this.getHeaderHeight();
		this.ticking = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.onResizeHandler = this.onResize.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);
		window.addEventListener('resize', this.onResizeHandler);
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
		window.removeEventListener('resize', this.onResizeHandler);
	}

	onResize() {
		this.scrollThreshold = this.getHeaderHeight();
	}

	getScrollTop() {
		return Math.max(window.pageYOffset || document.documentElement.scrollTop || 0, 0);
	}

	getHeaderHeight() {
		return this.header.offsetHeight || this.offsetHeight || 0;
	}

	onScroll() {
		if (this.ticking) return;

		this.ticking = true;
		requestAnimationFrame(() => {
			this.updateHeader();
			this.ticking = false;
		});
	}

	updateHeader() {
		const scrollTop = this.getScrollTop();
		const scrollDelta = scrollTop - this.currentScrollTop;
		if (this.header.classList.contains('is-search-drawer-open') || this.querySelector('header-drawer > details[open]')) {
			this.currentScrollTop = scrollTop;
			return;
		}

		if (Math.abs(scrollDelta) < 4) return;

		if (this.headerIsAlwaysSticky) {
			if (scrollTop > this.scrollThreshold) {
				this.stickAlways();
			} else {
				this.reset();
			}
			this.currentScrollTop = scrollTop;
			return;
		}

		if (scrollTop <= this.scrollThreshold) {
			this.reset();
		} else if (scrollDelta > 0) {
			if (!this.preventHide) {
				this.hide();
			}
		} else {
			this.reveal();
		}

		this.currentScrollTop = scrollTop;
	}

	stickAlways() {
		this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
		this.header.classList.remove('shopify-section-header-hidden', 'color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-3');
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'shopify-section-header-always-sticky', 'animate');
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-3');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	if (!customElements.get('sticky-header')) {
		customElements.define('sticky-header', StickyHeader);
	}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
